import React, {Component} from 'react';
import PropTypes from 'prop-types';

import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SearchInput from "core/gd-ui/search/search";

export default class GitSelectBranch extends Component {

    static propTypes = {
        repositories: PropTypes.array,

        onClick: PropTypes.func,
        onSelectBranch: PropTypes.func,
    }

    state = {
        searchString: ''
    }

    onSearchChange = (searchString) => {
        this.setState({
            searchString: searchString
        });
    };

    renderList = () => {
        let branches = this.props.repository['branches'];

        if (this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase();
            branches = _.filter(branches, b=>b.name.toLowerCase().includes(searchString))
        }

        return (
            <div className="list">
                {branches.map((branch) =>(
                    <div key={branch.id} className="list-item repository" onClick={() => this.props.onSelectBranch(branch)}>
                        <div className={Classes('icon', 'i5-git-branch')}/>
                        <div className="label">{branch.name}</div>
                    </div>
                ))}
            </div>
        )
    };

    render() {
        return (
            <div className="main" >
                <div className="search">
                    <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                </div>

                <VScroll containerClass="main-container">
                    {this.renderList()}
                </VScroll>
            </div>
        );
    }
}
